<template>
    <v-btn small block color="font-weight-bold" @click="copy">
        <v-row class="my-0" align="center">
            <v-col class="text-start"> {{ link }} </v-col>
            <v-col cols="auto">
                <v-icon small>mdi-content-copy</v-icon>
            </v-col>
        </v-row>
    </v-btn>
</template>

<script>
export default {
    computed: {
        link() {
            return document.location;
        },
    },
    methods: {
        copy() {
            navigator.clipboard.writeText(this.link).then(() => alert("주소가 복사되었습니다"));
        },
    },
};
</script>

<style>
</style>